module.exports = __webpack_public_path__ + "img/row-bgimage-1.aa2f59ee.jpg";